import { homePath, LOCALE_NAMES, SUPPORTED_LOCALES, type Locale } from '@snakefeast/shared';

/**
 * Links to the landing in every language, so search engines find each one. In the app, `onPick`
 * switches language in place (and remembers it) instead of reloading.
 */
export function LanguageLinks({ label, current, onPick }: { label: string; current: Locale; onPick?: (l: Locale) => void }) {
  return (
    <nav className="landing-langs" aria-label={label}>
      {SUPPORTED_LOCALES.map((l) => (
        <a
          key={l}
          href={homePath(l)}
          hrefLang={l}
          lang={l}
          aria-current={l === current ? 'page' : undefined}
          onClick={onPick ? (e) => (e.preventDefault(), onPick(l)) : undefined}
        >
          {LOCALE_NAMES[l]}
        </a>
      ))}
    </nav>
  );
}
